import { CLEAR_ALL, LOGOUT } from '../../../../store/Types';

export const ALL_PLANEVA_TEMAS = 'ALL_PLANEVA_TEMAS';
export const ACTIVO_PLANEVA_TEMAS = 'ACTIVO_PLANEVA_TEMAS';
export const LOADING_ALL_PLANEVA_TEMAS = 'LOADING_ALL_PLANEVA_TEMAS';
export const LOADING_UPDATE_ESTATUS_PLANEVA_TEMAS =
  'LOADING_UPDATE_ESTATUS_PLANEVA_TEMAS';
export const PARAMS_PLANEVA_TEMAS = 'PARAMS_PLANEVA_TEMAS';

const initialState = {
  all: [],
  loadingAll: false,
  activo: null,
  loadingUpdateEstatus: false,
  params: {},
};

export const planevaTemasReducer = (state = initialState, action) => {
  switch (action.type) {
    case ALL_PLANEVA_TEMAS:
      return {
        ...state,
        all: action.payload.data,
        links: action.payload.links,
        meta: action.payload.meta,
      };
    case ACTIVO_PLANEVA_TEMAS:
      return {
        ...state,
        activo: action.payload,
      };
    case LOADING_ALL_PLANEVA_TEMAS:
      return {
        ...state,
        loadingAll: action.payload,
      };
    case LOADING_UPDATE_ESTATUS_PLANEVA_TEMAS:
      return {
        ...state,
        loadingUpdateEstatus: action.payload,
      };
    case PARAMS_PLANEVA_TEMAS:
      return {
        ...state,
        params: action.payload,
      };
    case CLEAR_ALL:
      return {
        ...state,
        ...initialState,
      };
    case LOGOUT:
      return {
        ...state,
        ...initialState,
      };
    default:
      return state;
  }
};
